import { useMemo } from 'react'
import { round } from 'vend-number'
import { useAppSelector } from '../../../../state/hooks'
import { selectOutstandingBalance } from '../../../../state/slices/currentSale/currentSaleSlice'

/** Default Pay-field amount: the sale's outstanding balance. */
export const useDefaultPayAmount = () => {
  const outstandingBalance = useAppSelector(selectOutstandingBalance)

  return useMemo(() => round(outstandingBalance.toString(), 2), [
    outstandingBalance,
  ])
}
